// extracted by mini-css-extract-plugin
export default {"bar":"AppBar_bar__NOqL5","sidebar-opened":"AppBar_sidebar-opened__jAnll"};